import { render } from "./reloadcache.vue?vue&type=template&id=ca449c16&scoped=true&ts=true"
import script from "./reloadcacheHelper.ts?vue&type=script&lang=ts"
export * from "./reloadcacheHelper.ts?vue&type=script&lang=ts"

import "./reloadcache.vue?vue&type=style&index=0&id=ca449c16&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca449c16"]])

export default __exports__